import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/router/routes';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-slate-800 text-slate-300 text-xs py-4 px-6 border-t border-slate-700">
      <div className="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
        <div>
          Copyright © 2026 Athletiverse, Inc. All rights reserved.
        </div>

        <div className="flex space-x-4">
          <button
            onClick={() => navigate(ROUTES.TERMS)}
            className="hover:text-white transition-colors"
          >
            Terms & Conditions
          </button>
          <button
            onClick={() => navigate(ROUTES.PRIVACY)}
            className="hover:text-white transition-colors"
          >
            Privacy Statement
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;